<template>
  <div class="GlobalTable">
    <div style="display: flex;justify-content: space-between;margin-bottom: 30px;">
      <div class="ts_left">
        <div class="blueLine"></div>
        <span>合计：</span>
        <p>总入账：<span style="color: #80C269;font-weight: 600;">{{ resData.totalInNums || 0 }}笔 {{ resData.totalInBalance
          || 0 }}元</span></p>
        <p>总出账：<span style="color:red;font-weight: 600;">{{ resData.totalOutNums || 0 }}笔 {{ resData.totalOutBalance ||
          0 }}元</span></p>
        <p>净入账：<span style="color: #80C269;font-weight: 600;">{{ resData.netAmountReceived || 0 }}元</span></p>
      </div>
      <div>
      </div>
    </div>
    <template>
      <GlobalTable ref="merchantTable" v-loading="loading" :columns="tableColumns1" :data="this.seachDataList"
        :currentPage="page.pageNum" :total="page.total" @handleCurrentChange="handleCurrentChange">
        <el-table-column label="流水号" slot="uniqNo" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.uniqNo || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="关联订单号" slot="relationNo" align="center">
          <template slot-scope="{ row }">
            <div style="color: #0981ff;cursor: pointer;" @click="toOrderDetails(row)">
              <span style="border-bottom: 1px solid #0981ff">{{ row.relationNo }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="交易商家类型" slot="enterpriseType" align="center">
          <template slot-scope="{ row }">
            <div>{{ row.enterpriseType == 'merchant' ? '回收商' : row.enterpriseType == 'company' ? '门店商' : '--' }}</div>
          </template>
        </el-table-column>
        <el-table-column label="门店商户" slot="companyName" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.companyName || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="账单类型" slot="opt" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.opt == '01' ? '入账' : row.opt == '02' ? '出账' : '挂账' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="金额" slot="amount" align="center">
          <template slot-scope="{ row }">
            <span :style="row.opt == '01' ? 'color:green' : 'color:red'" v-if="row.opt != '03'">{{ row.amount >= 0 &&
              row.opt ==
              '01' ? `+${row.amount}` : `-${row.amount}` }}</span>
            <span :style="row.serType == '15' || row.serType == '23' ? 'color:green' : 'color:red'" v-else>{{
              row.amount
                &&
                (row.serType == '15' || row.serType == '23') ? `+${row.amount}` : `-${row.amount}` }}</span>
          </template>
        </el-table-column>
        <el-table-column label="账户结余" slot="afterAmount" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.afterAmount || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="备注" width="130rpx" slot="remark" align="center">
          <template slot-scope="{ row }">
            <el-tooltip class="item" effect="dark" :content="row.remark" placement="top">
              <div class="Remarks">
                {{ row.remark }}
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
      </GlobalTable>
    </template>
    <!-- <template v-if="Array.isArray(seachDataList) && seachDataList.length > 0">

    </template> -->
    <!-- <template v-else>
      <div v-loading="searchTabLoading" v-if="seachDataList.length <= 0"
        style="width: 100%; text-align: center; padding: 80px 0px; font-size: 24px; color: rgb(102, 102, 102); background: white; font-weight: bold;">
        暂无数据~
      </div>
    </template> -->

  </div>
</template>

<script>
import { http } from "@/utils/request/revenue"

export default {
  props: {
    modeList: {
      require: true,
      type: Array
    },
  },
  data() {
    return {
      searchTabLoading: true,
      loading: false,
      seachDataList: [],
      page: {
        pageNum: 1,
        pageSize: 10
      },
      pageNum: 1,
      tableColumns1: [
        { slotName: "uniqNo" },
        { slotName: "relationNo" },
        { slotName: "enterpriseType" },
        { label: "回收商", prop: "merchantName" },
        { slotName: "companyName" },
        { label: "账单时间", prop: "createTime" },
        { label: "所属渠道", prop: "matchName" },
        { label: "费用类型", prop: "accountName" },
        { slotName: "opt" },
        { label: "子类型", prop: "title" },
        { slotName: "amount" },
        { slotName: "afterAmount" },
        { label: "报价金额", prop: "qcQuotePrice" },
        { slotName: "remark" }
      ],
      resData: {}
    };
  },
  created() {
    this.handleCurrentChange();
  },
  computed: {
    SeachParams() {
      return this.$store.state.tagsView.SeachParams
    },
  },
  watch: {
    SeachParams(newVal) {
      console.log(newVal)
      this.page.pageNum = 1;
      this.handleCurrentChange()
    },
  },
  methods: {
    // 表格切换页面
    handleCurrentChange(val) {
      if (val) {
        this.pageNum = val
        this.page.pageNum = val;
      }
      const { pageNum, pageSize } = this.page
      http.getList({
        ...this.SeachParams,
        pageType: '04',
        pageNum,
        pageSize
      }).then(res => {
        if (res.code === 1) {
          console.log('this.modeList', this.modeList);

          this.seachDataList = res.data.ipage.records
          this.resData = res.data
          this.page.total = res.data.ipage.total;
          this.page.pageNum = res.data.ipage.current;
          this.loading = false
          this.searchTabLoading = false;
          console.log(this.seachDataList, '22222222');
        }
      }).finally(() => {
        if (typeof this.SeachParams.disuseLoding == "function") {
          this.SeachParams.disuseLoding();
        }
      });
    },
    toOrderDetails(row) {
      const route = this.$router.resolve({
        path: "/RecallOrder/Details",
        query: { type: "edit", id: row.relationNo },
      });

      window.open(route.href, '_blank');
    },


  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.blueLine {
  margin-right: 10px;
  width: 4px;
  height: 24px;
  background: #4c84ff;
  border-radius: 2px;
  background-color: #0981ff;
}

.ts_left {
  display: flex;
  align-items: center;

  p {
    margin-left: 30px;
  }
}

.GlobalTable {

  // 备注说明
  .Remarks {
    width: 100%;
    height: 100%;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2; //控制行数
    overflow: hidden;
  }

  .operation-btn {
    /deep/.el-button {
      margin-left: 0;
    }
  }

  .isdeal1 {
    border: 1px solid #f59a23;
    display: inline-block;
    width: max-content;
    padding: 0px 4px;
    font-size: 14px;
    margin: 0 auto;
    border-radius: 5px;
    color: #f59a23;
    text-align: center;
    margin-left: 5px;
  }
}
</style>
